import { render, staticRenderFns } from "./TrainerknowledgeBase.vue?vue&type=template&id=371121ae"
import script from "./TrainerknowledgeBase.vue?vue&type=script&lang=js"
export * from "./TrainerknowledgeBase.vue?vue&type=script&lang=js"
import style0 from "./TrainerknowledgeBase.vue?vue&type=style&index=0&id=371121ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports